import { Close } from '@mui/icons-material'
import { Dialog, IconButton, Typography, Divider, Button } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'
import { InfoCardIcon } from 'components/atoms/Icons'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import logoAvatarIcon from 'assets/images/logoAvatar.svg'
import featurePowerIcon from 'assets/images/featurePower.svg'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import { useTranslation, Trans } from 'react-i18next'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { MONARK_SUPPORT_EMAIL } from 'utils/constants'

const UnlockFeaturesDialog = ({ open, onClose }) => {
  const { t } = useTranslation()
  const typoSx = {
    textAlign: 'center'
  }

  const RenderFeaturePoint = ({ i18nKey }) => {
    return (
      <RowStack spacing={6}>
        <CheckCircleOutlinedIcon
          color='primary'
          sx={{ strokeWidth: 1, stroke: 'background' }}
        />
        <Typography variant='body1'>
          <Trans i18nKey={i18nKey} />
        </Typography>
      </RowStack>
    )
  }

  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
      sx={{
        '& .MuiDialog-paper': {
          width: 480,
          paddingX: 12,
          paddingY: 16,
          borderRadius: 5,
          position: 'relative'
        }
      }}>
      <IconButton
        sx={{
          position: 'absolute',
          right: 15,
          top: 10
        }}
        onClick={() => onClose()}>
        <Close sx={{ color: colors.Grey400 }} />
      </IconButton>

      <InCardStack spacing={12}>
        <InCardStack spacing={8}>
          <RowStack spacing={3} justifyContent={'center'}>
            <InfoCardIcon src={logoAvatarIcon} size={64} />
            <AddRoundedIcon sx={{ fontSize: 44, strokeWidth: 0.5 }} />
            <InfoCardIcon src={featurePowerIcon} size={64} />
          </RowStack>

          <InCardStack spacing={4}>
            <Typography variant='h2' sx={typoSx}>
              {t('myTeam.unlockMonarkFeatures')}
            </Typography>

            <Typography variant='body1' sx={typoSx}>
              {t('myTeam.upgradeNowToUnlock')}
            </Typography>
          </InCardStack>
        </InCardStack>

        <BoxWithBackground
          sx={{
            paddingX: 10,
            paddingY: 12,
            width: '100%',
            backgroundColor: colors.MetalGrey50
          }}>
          <InCardStack>
            <Typography variant='h3'>{t('myTeam.withMonarksTool')}</Typography>

            <InCardStack spacing={6}>
              <RenderFeaturePoint i18nKey={'myTeam.automaticallySync'} />
              <RenderFeaturePoint i18nKey={'myTeam.scheduleNewOne'} />
              <RenderFeaturePoint i18nKey={'myTeam.centralizeMeetings'} />
              <RenderFeaturePoint i18nKey={'myTeam.capturePrivateNotes'} />
              <RenderFeaturePoint i18nKey={'myTeam.accessIntelligent'} />
            </InCardStack>

            <Divider
              sx={{
                width: '100%'
              }}
            />

            <Typography variant='body1' sx={typoSx}>
              {t('myTeam.ableToStreamlinePerformance')}
            </Typography>
          </InCardStack>
        </BoxWithBackground>

        <Button
          href={`mailto:${MONARK_SUPPORT_EMAIL}?subject=${encodeURIComponent(t('welcomeArea.raterOnlySubject'))}`}>
          {t('myTeam.requestUpgrade')}
        </Button>
      </InCardStack>
    </Dialog>
  )
}

export default UnlockFeaturesDialog
